// extracted by mini-css-extract-plugin
export default {"alert":"FormError_alert__5cWRR","error":"FormError_error__7CLXd","text":"FormError_text__Jb0RD"};